//#region src/kiosk_peripheral_type.ts
var KioskPeripheralType = /* @__PURE__ */ function(KioskPeripheralType) {
	KioskPeripheralType[KioskPeripheralType["Printer"] = 1] = "Printer";
	KioskPeripheralType[KioskPeripheralType["HybridPrinter"] = 2] = "HybridPrinter";
	KioskPeripheralType[KioskPeripheralType["Display"] = 3] = "Display";
	KioskPeripheralType[KioskPeripheralType["Keyboard"] = 4] = "Keyboard";
	KioskPeripheralType[KioskPeripheralType["Scanner"] = 5] = "Scanner";
	KioskPeripheralType[KioskPeripheralType["Scale"] = 6] = "Scale";
	KioskPeripheralType[KioskPeripheralType["MSR"] = 7] = "MSR";
	KioskPeripheralType[KioskPeripheralType["HID"] = 8] = "HID";
	KioskPeripheralType[KioskPeripheralType["StormAudioNav"] = 9] = "StormAudioNav";
	return KioskPeripheralType;
}(KioskPeripheralType || {});
//#endregion
export { KioskPeripheralType };

//# sourceMappingURL=kiosk_peripheral_type.js.map